module.exports = __webpack_public_path__ + "media/video101.1adaa418.mp4";